/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum KS_customerservice_Service_Data_DataPointInvitationStatus {
    '_0' = 0,
    '_1' = 1,
}
